import { FC } from 'react';
import { ImageUrl } from '../../constants/image-urls';
import { TestData } from '../../types';
import { convertBGNToEUR, formatBGN } from "../../helpers/currency";

interface TableItemNoSubCategoryProps {
  testIndex: number;
  test: TestData;
}

export const TableItemNoSubCategoryMobile:FC<TableItemNoSubCategoryProps> = ({ testIndex, test }) => {

  return (
    <a
      href={`/test/${test ? test.slug : 'test'}`} key={testIndex}
      data-w-id="6cf0a404-3286-5840-aeaf-25e81d8c0532"
      className="test-link-card price w-block">
      <div className="flex items-center justify-between space-x-2 flex-wrap">
        <h3 className="title test-title text-left">
          {test ? test.name : 'Test'}
        </h3>

        <div className="test-details">
          {/*<div className="test-card-tag smaller-margin">*/}
          {/*  <div className="card-image-box h-5">*/}
          {/*    <img src={ImageUrl.CLOCK_ICON} alt=""*/}
          {/*         className="image"/></div>*/}
          {/*  <div className="duration-number">*/}
          {/*    {test[0].duration >= 1 ? `${test[0].duration[0]} работни дни` : '1 работен ден'}*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="test-price-tag tag-margin">
            <div className="card-image-box h-5">
              <img width="16" src={ImageUrl.PRICE_ICON} alt=""
                   className="image"/>
            </div>
            <div className="price-number">
              {(test.price?.length || test.price) && (
                <>
                  <span>{convertBGNToEUR(test.price?.replace('лева', '').trim())}</span>
                  <span>&nbsp;/&nbsp;</span>
                  <span>{formatBGN(test.price?.replace('лева', ''))}</span>
                </>
              )}

              {test.price?.length === 0 && (
                <span>-</span>
              )}
            </div>
          </div>

          {/*{test[0].sample && (*/}
          {/*  <div className="test-sample-tag">*/}
          {/*    <div className="card-image-box  h-5">*/}
          {/*      <img src={ImageUrl.SAMPLE_ICON_EMPTY} alt=""*/}
          {/*           className="image"/>*/}
          {/*    </div>*/}
          {/*    <div className="sample">*/}
          {/*      {test[0].sample}*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
        </div>
        <div className="info-icon"><img
          // style="display:block;opacity:1"
          loading="lazy"
          src={ImageUrl.INFO_ICON}
          alt=""
          className="normal"/><img
          // style="opacity:0;display:none"
          loading="lazy"
          src={ImageUrl.INFO_ICON_HOVER}
          alt="" className="hover"/></div>
      </div>
    </a>
  )
}
